<template>
  <div class="exam-guide-result">
    <div class="exam-guide-result__top">
      <bread-crumbs />
    </div>
    <div class="exam-guide-result__wrapper">
      <div class="exam-guide-result__content">
        <exam-search
          :results="true"
          :input-text="searchText"
          @updateList="updateList"
          @loading="updateLoading"
          @searchAll="handleSearchAll"
        />
      </div>
      <div class="exam-guide-result__side" />
    </div>
    <div class="exam-guide-result__wrapper">
      <div class="exam-guide-result__content exam-guide-result__content-bottom">
        <exam-search-result
          :items="items"
          :loading="loading"
        />
        <div
          v-if="loading"
          class="exam-guide-result__loading"
        >
          <spinner />
        </div>
        <div
          v-if="searchAll"
          v-observe-visibility="visibilityChanged"
        />
      </div>
      <div
        class="exam-guide-result__side"
        style="min-height: 350px"
      >
        <div class="exam-guide-result__sidebar">
          <h3>Exames mais pesquisados</h3>
          <ul class="exam-guide-result__list">
            <li
              v-for="item in popular"
              :key="item.id"
            >
              <a @click="handlePopularClick(item.mnemonic)">
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import examGuideService from '@/api/examGuide'
import BreadCrumbs from './components/BreadCrumbs.vue'
import ExamSearch from './components/ExamSearch.vue'
import ExamSearchResult from './components/ExamList.vue'
import Spinner from '../common/Spinner.vue'

export default {
  name: 'ExamGuideResult',
  components: { ExamSearch, ExamSearchResult, Spinner, BreadCrumbs },
  data: () => ({
    searchText: '',
    searchAll: false,
    popular: [],
    items: [],
    loading: false,
    page: 0, // at backend page starts on zero
  }),
  async mounted() {
    await this.$recaptchaLoaded()
    this.setupRecaptchaInterceptor()
    examGuideService.mostSearched().then(res => {
      this.popular = res.data
    })
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText
      this.searchExamByText(this.searchText)
    } else {
      this.searchAllExams()
    }
  },
  beforeDestroy() {
    if (this.axiosInterceptor !== null) {
      examGuideService.axios().interceptors.request.eject(this.axiosInterceptor)
    }

    if (this.$recaptchaInstance) {
      this.$recaptchaInstance.hideBadge()
    }
  },
  methods: {
    setupRecaptchaInterceptor() {
      this.axiosInterceptor = examGuideService.axios().interceptors.request.use(
        async config => {
          if (config.baseURL === process.env.EXAM_GUIDE_URL) {
            try {
              const token = await this.$recaptcha('exam_guide_request')
              config.headers['X-Recaptcha-Token'] = token
            } catch (error) {
              console.error('Erro ao obter token reCAPTCHA:', error)
            }
          }
          return config
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    handlePopularClick(mnemonic) {
      this.$router.push({
        path: '/exames/detalhes',
        query: { mnemonic },
      })
    },
    handleSearchAll(searchAll) {
      this.searchAll = searchAll
      this.page = 0
    },
    visibilityChanged(isVisible) {
      if (isVisible && !this.loading) {
        this.searchAllExams()
      }
    },
    updateList(items) {
      this.items = items
    },
    updateLoading(loading) {
      this.loading = loading
    },
    searchExamByText(text) {
      this.searchAll = false
      this.loading = true
      examGuideService
        .examSearch(text)
        .then(res => {
          this.items = res.data
          this.loading = false
          this.page++
        })
        .catch(() => {
          this.items = []
          this.loading = false
        })
    },
    searchAllExams() {
      this.searchAll = true
      this.loading = true
      examGuideService
        .examSearchAll(this.page)
        .then(res => {
          this.items = this.items.concat(res.data)
          this.loading = false
          this.page++
        })
        .catch(() => {
          this.items = []
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.exam-guide-result {
  background-color: #f7f7f7;
  background-image: url('/static/images/site/bg-result1.svg');
  background-repeat: no-repeat;
  background-position: -100px -185px;
  background-size: 500px auto;

  &__side {
    width: 30%;
    position: relative;
  }
  &__loading {
    min-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__sidebar {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    padding: 18px 15px;
    border-radius: 5px 0 0 0;
    min-width: 250px;
    background-color: #fff;

    h3 {
      font-size: 14px;
      color: #7f1a54;
      margin-bottom: 10px;
    }
  }
  &__wrapper {
    display: flex;
    margin-top: 25px;
  }

  &__list {
    a {
      font-size: 13px;
      text-decoration-line: underline !important;
      color: #7a7a7a !important;
      cursor: pointer;
    }
  }
  &__content {
    width: 70%;
    padding: 0px 80px 0 10%;
  }
}
</style>
